module.exports = __webpack_public_path__ + "static/media/login-background.8c9c4f9d.jpg";